import { ParamType } from '../calls/types/global'
import { DateTime } from 'luxon'

const formatParam = (key: string, param: string) => `${key}=${param}`

export const stringifyParams = (obj: ParamType = {}, useArray = false) => {
    if (Object.keys(obj).length === 0) return null
    const params: Array<string> = []
    Object.entries(obj).forEach(([key, value]) => {
      if (!value) {
        return
      } else if (Array.isArray(obj[key]) && obj[key].length > 0) {
        if (useArray) {
          params.push(formatParam(key, `${obj[key]}`))
        } else {
          value.forEach((arr) => {
            params.push(formatParam(key, arr))
          })
        }
      } else if (value instanceof DateTime && DateTime.fromISO(value).isValid) {
        params.push(formatParam(key, DateTime.fromISO(value).toISODate()))
      } else if (!Array.isArray(obj[key])) {
        params.push(formatParam(key, value))
      }
    });
    return params.join('&')
  }
  